module.exports = __webpack_public_path__ + "static/img/8.61f8266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/8.jpg
// module id = hJN9
// module chunks = 1